module.exports = __webpack_public_path__ + "static/media/fotoVeci.375c7e30.jpeg";